import React, { Component } from 'react'
import Footer from './Footer'
import Header from './Header'
import MainRoutes from '../../MainRoutes'
import SharePopup from '../internal/Popups/SharePopup';

import { inject, observer } from 'mobx-react'

class Layout extends Component {

  render() {
    return (
      <div>
        <Header />
        { this.props.children }
        <Footer />

        <SharePopup />
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// /src/components/layout/Layout.js